import React from 'react'
import ProgressContainer from './ProgressContainer'
import { useMediaQueryScreen } from '../../hooks/useMediaQuery'
import GoalTile from './GoalTile'
import useTranslation from '../shared/TranslationProvider'

const ActionPlanInfo = ({ goal, timeline, getUserTrackerSections }) => {
  const { t } = useTranslation()
  const isXlScreen = useMediaQueryScreen('xl')
  const isLgScreen = useMediaQueryScreen('lg')

  const actionPlanProgressClass = isLgScreen ? 'mb-[6px]' : 'hidden'
  return (
    <div className="track-info flex flex-col pb-2 md:gap-2">
      <div className="flex flex-col justify-between lg:flex-row">
        <div className="flex flex-col">
          <div className="mb-[20px] flex flex-col gap-8 xl:flex-row">
            <div className="flex flex-col justify-between">
              <h1 className="m-0 p-0 font-roboto-slab text-[32px] font-[700] leading-tight text-primary">
                {t('title')}
              </h1>
              {isXlScreen && <h3>{t('your_first_steps')}</h3>}
            </div>
            <GoalTile
              variant="goal"
              goal={goal}
              getUserTrackerSections={getUserTrackerSections}
            />
            <GoalTile
              variant="timeline"
              goal={timeline}
              timeline={timeline}
              getUserTrackerSections={getUserTrackerSections}
            />
          </div>
          {isXlScreen && <Subtitle goal={goal} />}
        </div>
        <div className="flex flex-col gap-4 font-roboto-slab md:min-w-max lg:items-center">
          <h2 className={actionPlanProgressClass}>
            {t('action_plan_progress')}
          </h2>
          <ProgressContainer />
        </div>
      </div>
      {!isXlScreen && (
        <div className="mt-4 flex flex-col gap-4">
          <h3>{t('your_first_steps')}</h3>
          <Subtitle goal={goal} />
        </div>
      )}
    </div>
  )
}

const Subtitle = ({ goal }) => {
  const { t } = useTranslation()
  return (
    <p>
      {t('welcome_message', {
        goal: goal.toLowerCase().replace(/myself/, 'yourself'),
      })}
    </p>
  )
}

export default ActionPlanInfo
